import LegacyProfile from './LegacyProfile';
class LegacyMoralProfile extends LegacyProfile {
    isLegalPerson() {
        return true;
    }
}
export default LegacyMoralProfile;
